import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import {EnrichedMaxItemsConfig} from "models/search"

export const hideNumberOfItems = (maxItems: number) => {
    const total = maxItems + 1
    return `n + ${total}`
}

type UlProps = {
    maxitems: EnrichedMaxItemsConfig
}

export const Container = styled("div")`
    span {
        font-size: 0.875rem;
        letter-spacing: 0.12px;
        line-height: 1.5;
        display: inline-block;

        > strong {
            font-family: ${({theme}) => `${theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
            text-transform: ${({theme}) => `${theme.uxfabric.global.subtitle2.textTransform}`};
            line-height: ${({theme}) => `${theme.uxfabric.global.subtitle2.lineHeight}`};
        }

        @media (min-width: ${breakpoints.values.md}px) {
            padding-top: 0.375rem;
            margin-top: 0.125rem;
        }
    }
`

export const ListContainer = styled("ul")<UlProps>`
    margin: 0;
    padding: 0;
    list-style: none;

    display: flex;
    justify-content: normal;
    width: 100%;
    overflow-x: scroll;
    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    @media (min-width: ${breakpoints.values.md}px) {
        overflow-x: initial;
    }

    li {
        max-width: ${props => `calc(1000px / ${props.maxitems.sm})`};
        flex-basis: calc(1000px / (${props => props.maxitems.sm}));

        @media (max-width: ${breakpoints.values.sm - 1}px) {
            &:nth-of-type(${props => hideNumberOfItems(props.maxitems.xs)}) {
                display: none;
            }
        }
        @media (max-width: ${breakpoints.values.md - 1}px) {
            min-width: 125px;
        }

        @media (min-width: ${breakpoints.values.sm}px) and (max-width: ${breakpoints.values.md - 1}px) {
            max-width: calc(100% / ${props => props.maxitems.sm});
            flex-basis: calc(100% / ${props => props.maxitems.sm});

            &:nth-of-type(${props => hideNumberOfItems(props.maxitems.sm)}) {
                display: none;
            }
        }
        @media (min-width: ${breakpoints.values.md}px) and (max-width: ${breakpoints.values.lg - 1}px) {
            flex-basis: calc(100% / ${props => props.maxitems.md});
            max-width: ${props => `calc(100% / ${props.maxitems.md})`};
            margin-right: 0;

            &:nth-of-type(${props => hideNumberOfItems(props.maxitems.md)}) {
                display: none;
            }
        }
        @media (min-width: ${breakpoints.values.lg}px) and (max-width: ${breakpoints.values.xl - 1}px) {
            max-width: ${props => `calc(100% / ${props.maxitems.lg})`};
            margin-right: 0;
            flex-basis: calc(100% / ${props => props.maxitems.lg});

            &:nth-of-type(${props => hideNumberOfItems(props.maxitems.lg)}) {
                display: none;
            }
        }
        @media (min-width: ${breakpoints.values.xl}px) {
            max-width: ${props => `calc(100% / ${props.maxitems.xl})`};
            margin-right: 0;
            flex-basis: calc(100% / ${props => props.maxitems.xl});

            &:nth-of-type(${props => hideNumberOfItems(props.maxitems.xl)}) {
                display: none;
            }
        }
    }
`
